enum Direction {
  FORWARD,
  BACKWARD,
}
export default Direction;
